export const parseFullName = (value: string) => {
  const [lastName = '', firstName = '', ...middleNameParts] = value.trim().split(/\s+/);

  return {
    lastName,
    firstName,
    middleName: middleNameParts.join(' '),
  };
};
